import React from 'react';
import PropTypes from 'prop-types';
import { TeamStatsWrapper, TeamStatsTable, FooterWrapper } from './TeamStats.style';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import BREAKPOINTS from '@mlb/react-patterns/v4/style/breakpoints';

const TeamStats = ({
    customCells,
    thead,
    tbody,
    mobileWidth,
    footer
}) => {
    const isMobile = (typeof mobileWidth === 'undefined') ? useMedia({ maxWidth: BREAKPOINTS.lg }) : mobileWidth;

    return (
        <TeamStatsWrapper>
            <TeamStatsTable
                hideDividers={true}
                headThPadding={'0'}
                bodyThPadding={'2px'}
                customCells={customCells}
                thead={thead}
                tbody={tbody}
                isMobile={isMobile}
                bodyTdPadding={isMobile ? '4px 0' : '10px 0'}
                tableFixed={false}
            />
            {footer && <FooterWrapper>{footer}</FooterWrapper>}
        </TeamStatsWrapper>

    );
};

TeamStats.propTypes = {
    customCells: PropTypes.array,
    thead: PropTypes.array,
    tbody: PropTypes.array,
    footer: PropTypes.string,
    mobileWidth: PropTypes.bool
};
export default TeamStats;
